import React from "react";
import {
  AContainer,
  ASkeleton,
  ASkeletonBlock,
  ASkeletonHeader,
  ASkeletonText
} from "@cisco-sbg-ui/magna-react";
import {Card} from "../components/Card";

const IncidentDetailSkeleton = () => {
  const skeletonContentBlock = new Array(3).fill(0).map((_, i) => (
    <ASkeleton
      nested
      hidePanelBackdrop
      className="pa-0"
      key={`${i}-skeleton-row`}>
      <Card title={<ASkeletonHeader />}>
        {new Array(10).fill(0).map((_, index) => (
          <ASkeletonText key={`${index}-skeleton-text`} />
        ))}
      </Card>
    </ASkeleton>
  ));
  return (
    <div style={{width: "100%"}}>
      <ASkeleton hidePanelBackdrop className="pb-0">
        <ASkeletonText />
        <ASkeletonBlock />
        <ASkeletonBlock />
        <ASkeletonBlock style={{width: "350px"}} />
      </ASkeleton>
      <ASkeleton className="mb-0">
        <ASkeletonBlock height={365} />
      </ASkeleton>
      <ASkeleton horizontal hidePanelBackdrop className="pa-0">
        {skeletonContentBlock}
      </ASkeleton>
    </div>
  );
};

export default IncidentDetailSkeleton;
